import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';
export function logoSource(venue) {
  const path = venue?.logo_url;
  if (typeof path === 'string' && /^\/api\/media\/venue-logos\/[a-f0-9]{64}$/.test(path)) return API + path;
  return venue?.id ? `${API}/api/media/venue-logos/by-venue/${encodeURIComponent(venue.id)}` : '';
}
export default function VenueLogo({ venue, className = '' }) {
  const src = logoSource(venue);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  if (!src || failed) return null;
  return <img src={src} onError={() => setFailed(true)} alt={`${venue?.name || 'Mekân'} logosu`}
    width="48" height="48" loading="lazy" decoding="async"
    style={{width:48,height:48,objectFit:'contain'}}
    className={`h-12 w-12 shrink-0 rounded-lg border bg-white object-contain p-1 ${className}`} />;
}
